import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('Unsubscribe')

const UnsubscribeSkeleton = ({ guestUser }) => {
    return (
        <div className={bem('skeletonWrapper')}>
            <Skeleton
                count={1}
                containerClassName={guestUser ? bem('skeletonButtonWrapper') : ''}
                className={bem('skeletonButton')}
            />
            <div className={bem('longParagraph', `last${guestUser ? '-center' : ''}`)}>
                <Skeleton count={2} className={bem('skeletonSpace')} />
                <Skeleton align={'left'} />
            </div>
            <Skeleton
                count={3}
                containerClassName={guestUser ? bem('skeletonButtonWrapper') : ''}
                className={bem('skeletonButton')}
            />
        </div>
    )
}

export default UnsubscribeSkeleton
